export class apiConstants {
    public static getSchoolDomain = "/get/school/domain/suggestions";
    public static verifySchoolDomain = "/verify/school/domain/availability";
    public static schoolRegistration = "/register/institute";
    public static genericLoginWithOtp = "/generic/login/with/otp";
    public static genericLoginWithPassword = "/generic/login/with/password";
    public static verifyOtp = "/verify/register/institute/otp";
    public static verifyOtpForGenericLogin = "/verify/otp/for/generic/login";
    public static verifySchoolDomainDetails = "/verify/school/domain";
    public static schoolDomainLoginWithOtp = "/school/domain/login/with/otp";
    public static schoolDomainLoginWithPassword =
        "/school/domain/login/with/password";
    public static getInstituteTypes = "/get/institute/types";
    public static addInstituteInformationDetails =
        "/add/institute/information/details";
    public static verifyOtpForDomainLogin = "/verify/otp/for/school/domain/login";
    public static getPaymentGatewayList = "/get/payment/gateway/list";
    public static paymentGatewayStatusUpdate = "/payment/gateway/status/update";
    public static sendPaymentGatewayRequest = "/send/payment/gateway/request"
    public static getRegistrationQuestionnaire = "/get/registration/questionnaire";
    public static schoolQuestionnaireAnswer = "/school/questionnaire/answers";
    public static getClassListWithAttendanceType = "/get/class/list/with/attendance/type";
    public static changeAttendanceTypeForParticularClass = "/change/attendance/type/for/particular/class";
    public static changeAttendanceTypeForAllClass = '/change/attendance/type/for/all/class';
    public static studentCategoriesGetFeeStructureStudentListDiscount = '/student/categories/get/fee/structure/student/list/discount';
    public static getStudentListDiscount = '/get/student/list/discount';
    public static sendOtpForForgotPassword = '/send/otp/for/admin'
    public static resetPassword = '/reset/password/for/admin';
    public static getSupportedCurrencyListAPI = "/get/supported/currency";
    public static supportedCurrencyUpdateAPI = "/update/supported/currency"
    public static getAcademicListAPI = '/get/academic/list';
    public static getAdmissionEnquiryCategoriesAPI = '/admission/enquiry/categories';
    public static getAdmissionEnquiryClassStandardsAPI = '/admission/enquiry/class/standards';
    public static getAdmissionEnquiryClassSectionsAPI = '/admission/enquiry/class/sections';
    public static addAdmissionEnquiryAPI = '/admission/enquiry/add';
    public static updateAdmissionEnquiryAPI = '/admission/enquiry/update';
    public static getAdmissionEnquiryListAPI = '/admission/enquiry/list';
    public static getAdmissionEnquiryStatusesAPI = '/admission/enquiry/statuses';
    public static getAdmissionEnquiryDetailAPI = '/admission/enquiry/detail';
    public static convertAdmissionEnquiryAPI = '/admission/enquiry/convert';
    public static exportAdmissionEnquiryAPI = '/admission/enquiry/export';
    public static getAcademicYearsAPI = '/get/past/current/academic/list';
    public static getBroadcastTypeAPI = '/get/broadcast/receiver/list';
    public static getBroadcastReceiverListV2API = '/get/broadcast/receiver/list/v2';
    public static createBroadcastAPI = '/create/broadcast';
    public static createBroadcastV2API = '/create/broadcast/v2';
    public static getBroadcastAPI = '/get/broadcast/messages';
    public static getBroadcastMessagesV2API = '/get/broadcast/messages/v2';
    public static getBroadcastReceiverDetailListAPI = '/get/broadcast/receiver/detail/list';
    public static getBroadcastMessagesForStaffAPI = '/get/broadcast/messages/staff';
    public static markBroadcastReadForStaffAPI = '/mark/broadcast/read/staff';
    public static getTimeZoneList = '/get/timezone/list';
    public static setSchoolTimeZone = '/insert/school/timezone/for/school';
    public static getAllTcForParticularJobApiEndpoint = '/get/all/tc/for/particular/job';
    public static emailTcApiEndpoint = '/email/transfer/certificate';
    public static getWingData = '/report/get/class/category/list';
    public static getClassStandardListInfo = '/report/class/standard/list';
    public static getClassStandardList = '/report/get/class/standard/list';
    public static getClassSectionData = '/report/get/class/section/list';
    public static getClassSectionDataInfo = '/report/class/section/list';
    public static getCategoryData = '/report/get/cast/category/list';
    public static getGenderList = '/report/get/student/gender/list';
    public static getStudentStatInfoData = '/report/get/category/wise/report/stats';
    public static getStudentStatInfo = '/report/category/wise/report/stats';
    public static getCategoryWiseTableDataInfo = '/report/get/category/wise/report/student/list';
    public static getCategoryWiseTableData = '/report/category/wise/report/student/list';
    public static getTcStatData = "/report/get/tc/birth/certificate/report/stats";
    public static getTcDetailedInfo = "/report/get/tc/birth/certificate/student/data";
    public static exportReport = "/export/report";
    public static exportReportData = "/report/export/category/wise/report";
    public static exportTcOrBirthCertificateReport = "/report/export/tc/birth/certificate/report";
    public static getClassListDataAttendance = "/report/get/class/category/list/for/attendance";
    public static getClassListCategory = "/report/get/class/standard/list/for/attendance";
    public static getSectionListData = "/report/get/class/section/list/for/attendance";
    public static getStudentListData = "/report/get/student/list/for/attendance";
    public static getStudentAttendanceStat = "/report/get/attendance/report/stats";
    public static getAllClassesData = "/report/get/attendance/report/class/data";
    public static getClassWiseData = "/report/get/attendance/report/student/data";
    public static getColorListApiEndpoint = '/get/default/color/list';
    public static createEventCategoryApiEndpoint = '/create/event/category';
    public static getEventCategoryApiEndpoint = '/get/category/list';
    public static editEventCategoryApiEndpoint = '/edit/event/category';
    public static deleteEventCategoryApiEndpoint = '/delete/event/category';
    public static getCompleteClassListApiEndpoint = '/get/class/list';
    public static getHolidaysListApiEndpoint = '/get/holiday/list';
    public static createHoildayApiEndpoint = '/create/holiday';
    public static editHoildayApiEndpoint = '/edit/holiday';
    public static deleteHoildayApiEndpoint = '/delete/holiday';
    public static getEventAPIEndpoint = '/get/event/list';
    public static getStaffListAPIEndpoint = '/get/staff/list';
    public static createEventAPIEndpoint = '/create/event';
    public static editEventAPIEndpoint = '/edit/event';
    public static deleteEventAPIEndpoint = '/delete/event';
    public static updateIsPublishedEventCalendarAPIEndpoint = '/publish/calendar';
    public static getAcademicYearsList = '/report/get/academic/list/for/fees';
    public static getAcademicStudentListForPendingFeeApiEndpoint = "/report/get/student/list/for/fees";
    public static getPendingFeeStat = "/report/get/fees/report/stats";
    public static getPendingFeeAllClassData = "/report/get/fees/report/class/data";
    public static getPendingFeeClassWiseData = "/report/get/fees/report/student/data";
    public static exportFeePendingReport = "/report/export/fees/report"
    public static exportAttendanceReport = "/report/export/attendance/report"
    public static getDocumentHubDocumentType = '/document/hub/get/document/type'
    public static uploadDocumentInDocumentHub = '/document/hub/upload/students/document'
    public static getUploadedDocumentData = '/document/hub/get/students/uploaded/documents'
    public static deleteUploadedDoc = '/document/hub/delete/uploaded/documents';
    public static previewDoc = '/document/hub/preview/documents';
    public static getClassListForFee = '/get/class/list/for/fees/structure/copy'
    public static staffLogin = '/login/staff'
    public static staffLoginWithPassword = '/login/staff/with/password/for/web'
    public static generateQrCodeForStaffLogin = '/generate/qr/code/for/staff/login/for/web'
    public static loginStaffWithQrCode = '/login/staff/with/qr/code/for/web'
    public static generateOtpForForgotPasswordForStaff = '/generate/otp/for/forgot/password/for/staff'
    public static verifyOtpForForgotPasswordForStaff = '/verify/otp/for/forgot/password/for/staff'
    public static resetPasswordForStaff = '/reset/password/for/staff'
    public static getStaffDashboardClassDetails = '/staff/dashboard/class/info/with/pagination'
    public static getFeeCollectionAcademicIdList = '/fee/collection/get/academic/id/list'
    public static getFeeCollectionMonthlyCollectedFees = '/fee/collection/get/monthly/collected/fees'
    public static getFeeCollectionDateWiseCollectedFees = '/fee/collection/get/date/wise/collected/fees'
    public static getBusList = '/bus/get/bus/list'
    public static getBusStopList = '/bus/get/bus/stop/list/for/bus'
    public static getStudentListForBus = '/bus/get/students/allocated/to/bus'
    public static getVehicleLocation = '/bus/get/updated/vehicle/location/for/staff'
    public static getStudentCheckInInfo = '/student/visit/get/student/checkin/checkout/list'
    public static getCheckInWingData = '/student/visit/get/class/category'
    public static getCheckInClassData = '/student/visit/get/class/standard'
    public static getCheckInClassStandardData = '/student/visit/get/class/section'
    public static searchProfile = '/search/profile'
    // Naming note: the app's own "Fee Pending Report" screen calls these
    // "overdue" endpoints under the hood — not a typo, that's just what the
    // backend/mobile app named them.
    public static getOverdueClassList = '/fees/overdue/get/class/wise/fees/data'
    public static getOverdueStudentList = '/fees/overdue/get/student/wise/fees/data'
    public static getOverdueStudentListHistory = '/fees/overdue/get/particular/student/fee/detail'
    public static refreshFeesData = '/update/fee/structure'
    // "Fees Overdue Report" screen — naming is inverted vs. the block above:
    // this screen (Overdue) calls endpoints literally named "pending", and
    // the "Fee Pending Report" screen above calls endpoints literally named
    // "overdue". Not a typo — that's genuinely how the backend/mobile app
    // named these two parallel flows.
    public static getPendingClassList = '/fee/overdue/get/class/wise/fees/overdue/detail'
    public static getPendingStudentList = '/fees/overdue/get/student/wise/fees/overdue/detail'
    public static getPendingStudentListHistory = '/fees/overdue/get/student/fees/overdue/details'
    public static refreshFeesDataOverdue = '/update/fee/overdue/structure'
    public static getStaffAcademicCalendarEvents = '/academic/calendar/get/event/details/staff'
    public static getParentAcademicCalendarEvents = '/academic/calendar/get/event/details/parent'
    // Lives under the /hourhive/ namespace — this data comes from the
    // Hourhive integration, even though it's a normal in-app list screen
    // (not a redirect into the Hourhive product itself).
    public static getStaffAttendance = '/hourhive/get/staff/attendance/detail'
    public static getParticularClassInfo = '/get/particular/class/info'
    public static getStaffPeriodList = '/get/period/list/for/staff'
    public static getSubjectForFilterDiary = '/get/subject/list/for/diary/filter/for/staff'
    public static getTodaysDiaryData = '/get/todays/date/diary/for/staff'
    public static getPastDiaryData = '/get/past/date/diary/for/staff'
    public static getUpcomingDiaryData = '/get/upcoming/date/diary/for/staff'
    public static getDiaryDetails = '/get/diary/detail/by/diary/id/for/staff'
    public static getSubjectForCreateDiary = '/get/subject/list/for/create/diary'
    public static getClassListForCreateDiary = '/get/staff/classes/for/particular/subject'
    public static createDiaryForStaff = '/create/diary'
    public static editDiaryForStaff = '/edit/diary'
    public static getClassTimetable = '/gettimetableclass'
    public static getStaffTimetable = '/get/staff/timetable'
    public static staffLogout = '/log/out/staff/web'
    public static getTeacherInfo = '/staff/info'
    public static sendStaffPasswordOnEmail = '/staff/send/password/on/email'
    public static getStudentListForAttendance = '/get/student/list/for/attendance/v2'
    public static markStaffAttendance = '/mark/attendance/v2'
    public static getActivityData = '/get/activities/list/staff'
    public static createActivity = '/create/activity/staff'
    public static editActivity = '/update/activity/staff'
    public static deleteActivity = '/delete/activity/staff'
    public static likeActivityPost = '/action/like/activity/staff'
    public static getActivityReactions = '/get/like/activity/staff'
    public static doActivityComment = '/action/comment/activity/staff'
    public static getActivityComment = '/get/comment/activity/staff'
    public static deleteActivityComment = '/delete/comment/activity/staff'
    public static editActivityComment = '/update/comment/activity/staff'
    public static getStudentBasicInfo = '/students/class/basicinfo'
    public static getStaffFeeAccess = '/get/staff/permission/details/for/fees/list'
    public static getStudentInfo = '/student/info'
    public static getFeesStudentWise = '/students/fee/details/with/staff/permission'
    public static getStudentAttendanceCalendar = '/get/attendance/list/staff'
    public static getStudentPartialAttendance = '/period/wise/attendance/list/staff'
    public static getUploadedDocuments = '/student/profile/view/uploaded/documents'
    public static getPayeeType = '/report/get/expense/report/payee/type'
    public static getPayeeName = '/report/get/expense/report/payee/name'
    public static getPaymentMethod = '/report/get/expense/report/payment/methods'
    public static getStatData = '/report/get/expense/report/stats'
    public static getReportData = '/report/get/expense/report/data'
    public static exportExpenseReport = '/report/export/expense/report'
    public static getSchoolSettingListAPI = '/get/school/settings';
    public static setSchoolSetting = '/update/school/settings';
    public static updateStaffFeesAccess = '/enable/disable/fees/access/for/staff';
    public static getcheckinCheckoutsearch = '/report/get/class/student/list';
    public static getCheckinCheckoutStats= '/report/get/checkinout/report/stats';
    public static getCheckinCheckoutTableData= '/report/get/checkinout/report/data';
    public static getcheckinCheckoutExportReport= '/report/get/checkinout/export/report/data';
    public static getStudentListAPIEndPoint = '/report/get/student/list';
    public static getFeeListData = '/report/get/fee/list';
    public static checkSortByRollNumber = '/report/check/sort/by/roll/number';
    public static getFeesOverdueReportStats = '/report/get/fees/overdue/report/stats';
    public static getFeesOverdueClassData = '/report/get/fees/overdue/report/class/data';
    public static getStudentWiseFeeDetails = '/report/get/fees/overdue/report/student/data';
    public static getColumnListForExportReport = '/report/get/columns/for/fees/overdue/report/export';
    public static exportFeesOverdueReport = '/report/export/fees/overdue/report';
    public static getClassStudentListForRollNumber = '/class/student/list';
    public static bulkUpdateStudentRollNumber = '/class/student/rollnumber/bulk/update';
    public static getStudentLeaveManagementList = '/get/student/leave/management/list';
    public static actionStudentLeaveRequest = '/action/student/leave/request';
    public static getLeaveManagementClassCategory = '/get/class/category/for/leave/management';
    public static getLeaveManagementClassStandard = '/get/class/standard/for/leave/management';
    public static getLeaveManagementClassSection = '/get/class/section/for/leave/management';
}